import colors from 'assets/theme/base/colors';
import pxToRem from 'assets/theme/function/px-to-rem';

const tablePagination = {
    styleOverrides: {
        default: {
            fontWeight: 500,
            fontSize: pxToRem(45),
            color: colors.common.white,
        },
        selectLabel: {
            fontSize: pxToRem(16),
            fontWeight: 500,
            color: colors.common.white,
        },
        displayedRows: {
            fontSize: pxToRem(16),
            fontWeight: 500,
            color: colors.common.white,
        },
        select: {
            fontSize: pxToRem(16),
            fontWeight: 500,
            color: colors.common.white,
        },
        action: {
            fontWeight: 500,
            color: colors.common.white,

            '& .MuiIconButton-root': {
                color: colors.common.white,

                '&.Mui-disabled': {
                    color: 'rgba(255,255,255,0.3)',
                    filter: 'blur(1px)',
                    cursor: 'not-allowed',
                },

                '& .MuiSvgIcon-root': {
                    fontSize: '1.8rem',
                },
            },
        },
        root: {
            '& .MuiSvgIcon-root': {
                fontSize: '1.5rem',
            },
        },
    },
};
export default tablePagination;
